<template>
    <div class="extra_sorting_table">

        <div class="lk-popup add_form" v-if="button === 'edit'" style="position: fixed;left: 0;right: 0;top: 12%;z-index: 999;height: auto;">
            <div class="title">
                <h1 style="display: inline-block;" v-if="!currentUser.id">Добавить пользователя</h1>
                <h1 style="display: inline-block;" v-else>Редактирование прав доступа</h1>
                <button class="cross" @click="button = null, currentUser = {}" style="background: none;border: 0; float: right"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" alt=""></button>
            </div>
            <div class="content_box">
                <div class="dish_form">

                    <div class="info_row">
                        <span class="input_description">E-mail пользователя</span>
                        <select class="select_user select_info full" v-model="currentUser.user_id">
                            <option v-if="currentUser.user_ids" :value="(currentUser.user_ids).toString()">{{currentUser.user_name}}</option>
                        </select>
                    </div>

                    <div class="info_row">
                        <span class="input_description">Права доступа</span>
                        <select class="select_info select_zone" name="amount" multiple v-model="currentUser.zone">
                            <option v-for="(zone, id) in zones" :key="id" :value="id">{{zone}}</option>
                        </select>
                    </div>

                    <button class="menu_item_btn" @click="saveData">Сохранить</button>
                </div>
            </div>
        </div>
        <div class="toolbar">
          <button @click="button = 'edit'">Добавить</button>
        </div>
        <table class="extra_table" id="extra_menu_table">
            <thead>
            <tr class="row">
                <th>E-mail</th>
                <th>Права доступа</th>
                <th></th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr class="row" v-for="(dop, index) in dops" :key="index">
                <td class="td">{{dop.user_name}}</td>
                <td class="td">{{Object.values(dop.zones).join(',')}}</td>
                <td class="td">
                    <button class="button edit" @click="(currentUser = dop, button = 'edit')">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/edit.svg" alt="">
                    </button>
                </td>
                <td class="td">
                    <button class="button cancel" @click="deleteDop(dop)">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/cancel.svg" alt="">
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
export default {
  name: 'dops',
  props: ['auth', 'id', 'mapinit', 'user'],
  data () {
    return {
      button: null,
      currentUser: {},
      table: null,
      dops: [],
      zones: []
    }
  },
  created () {
    if (this.auth.uid) this.loadRest()
    else {
      setTimeout(() => {
        if (this.auth.uid) this.loadRest()
      }, 100)
    }
  },
  methods: {
    deleteDop (dop) {
      if (confirm('Вы действительно хотите удалить этот доступ?')) {
        var formData = new FormData()
        formData.append('id', this.id)
        formData.append('uid', this.$root.auth.uid)
        formData.append('dop_id', dop.id)
        axios.post('https://lk.when-hungry.com/mobile/delete-dop',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(() => {
          this.table.destroy()
          this.dops.splice(this.dops.indexOf(dop), 1)
          setTimeout(() => {
            alert('Доступ удален')
          }, 1)
        })
      }
    },
    loadRest () {
      axios.get('https://lk.when-hungry.com/mobile/get-dops?uid=' + this.auth.uid + '&id=' + this.id).then(response => {
        this.dops = response.data.dops
        this.zones = response.data.zones
      })
    },
    saveData () {
      this.currentUser.restaurant_id = this.id
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('dop', JSON.stringify(this.currentUser))
      axios.post('https://lk.when-hungry.com/mobile/save-dop',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          this.table.destroy()
          this.loadRest()
          setTimeout(() => {
            alert('Изменения сохранены')
          }, 1)
          this.currentUser = {}
          this.button = null
        }
      })
    }
  },
  watch: {
    'button' (val) {
      let self = this
      if (val) {
        setTimeout(() => {
          $('.select_user').select2({
            width: '100%',
            ajax: {
              url: 'https://lk.when-hungry.com/site/search-user',
              dataType: 'json',
              processResults: function (data) {
                return {
                  results: $.map(data, function (key, item) {
                    return {
                      text: key,
                      id: item
                    }
                  })
                }
              }
            }
          }).val(this.currentUser.user_id).trigger('change.select2').on('select2:select', function () {
            self.currentUser.user_id = $(this).val()
          })
          $('.select_zone').select2({width: '100%'}).val(this.currentUser.zone).trigger('change.select2').on('select2:select', function () { self.currentUser.zone = $(this).val() })
        }, 300)
      }
    },
    id (val, oldVal) {
      if (val !== oldVal) {
        this.loadRest()
      }
    },
    dops () {
      setTimeout(() => {
        this.table = $('#extra_menu_table').DataTable({
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Искать:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          }
        })
      }, 300)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/restaurant/dops.vue